import React, { Component } from 'react';
import acuza from '../img/acuza.png';
import arawak from '../img/arawak.png';
import conagra from '../img/conagra.png';
import filasur from '../img/filasur.png';
import incasur from '../img/incasur.png';
import bullfrog from '../img/bullfrog.png';
import inka from '../img/inka crops.png';
import villa from '../img/villa natura.png';
import '../css/Empresas.css';
import '../js/CarrucelEmpresas.js';
class Empresas extends Component {
	render() {
		return (
			<div style={{ backgroundColor: 'white', width: '100%', height: '550px', textAlign: "center" }}>
				<h1>Confían en <strong>Nosotros</strong></h1>
				<h3 style={{ fontSize: '19px', fontFamily: 'font-Light' }}>Algunas Empresas que pusieron en nuestras manos el</h3>
				<h3 style={{ margin: 0, fontSize: '19px', fontFamily: 'font-Light' }}> desarrollo de sus proyectos</h3>
				<div class="container">
					<div class="row">
						<div class="col-xs-11 col-md-10 col-centered" style={{ width: '100%' }}>
							<div id="carousel" class="carousel slide" data-ride="carousel" data-interval="2000">
								<div class="carousel-inner" style={{ height: '410px' }}>
									<div class="item active">
										<div class="carousel-col" style={{ marginTop: '90px' }}>
											<div class="block green img-responsive">
												<img style={{ marginTop: '60px', width: '160px', height: '90px' }} src={acuza}></img>
											</div>
										</div>
										<div class="carousel-col" style={{ marginTop: '90px' }}>
											<div class="block green img-responsive">
												<img style={{ marginTop: '60px', width: '160px', height: '90px' }} src={arawak}></img>
											</div>
										</div>
										<div class="carousel-col" style={{ marginTop: '90px' }}>
											<div class="block green img-responsive">
												<img style={{ marginTop: '60px', width: '160px', height: '90px' }} src={incasur}></img>
											</div>
										</div>
										<div class="carousel-col" style={{ marginTop: '90px' }}>
											<div class="block green img-responsive">
												<img style={{ marginTop: '60px', width: '160px', height: '90px' }} src={bullfrog}></img>
											</div>
										</div>
									</div>
									<div class="item">

										<div class="carousel-col" style={{ marginTop: '90px' }}>
											<div class="block green img-responsive">
												<img style={{ marginTop: '60px', width: '160px', height: '90px' }} src={inka}></img>
											</div>
										</div>


										<div class="carousel-col" style={{ marginTop: '90px' }}>
											<div class="block green img-responsive">
												<img style={{ marginTop: '60px', width: '160px', height: '90px' }} src={villa}></img>
											</div>
										</div>


										<div class="carousel-col" style={{ marginTop: '90px' }}>
											<div class="block green img-responsive">
												<img style={{ marginTop: '60px', width: '160px', height: '90px' }} src={conagra}></img>
											</div>
										</div>


										<div class="carousel-col" style={{ marginTop: '90px' }}>
											<div class="block green img-responsive">
												<img style={{ marginTop: '60px', width: '160px', height: '90px' }} src={filasur}></img>
											</div>
										</div>

									</div>
								</div>
								<div class="left carousel-control">
									<a href="#carousel" role="button" data-slide="prev">
										<span style={{ color: 'white' }} class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
										<span class="sr-only">Previous</span>
									</a>
								</div>
								<div class="right carousel-control">
									<a href="#carousel" role="button" data-slide="next">
										<span style={{ color: 'white' }} class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
										<span class="sr-only">Next</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)

	}
}

export default Empresas;


// WEBPACK FOOTER //
// ./src/components/Empresas.jsx